import { render, staticRenderFns } from "./WhatsNewFirst.vue?vue&type=template&id=6f36d8c1&lang=pug"
import script from "./WhatsNewFirst.vue?vue&type=script&lang=js"
export * from "./WhatsNewFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports